<template>
  <div id="home-tendencias" class="scroll-snap">
    <div class="section-bg"></div>
    <section class="sc-main">
      <div class="ig-data">
        <a class="clipped-bg" target="_blank" :href="'https://www.instagram.com/' + link_instagram">
          <i class="fa-brands fa-instagram"></i><span>fabrictienda</span>
        </a>
      </div>
      <div class="instagramMedia-wrapper">
        <a
          target="_blank"
          v-for="(item, index) in instagramMedia"
          :key="index"
          :href="item.permalink"
          :style="{ 'background-image': 'url(' + item.media_url + ')' }"
        >
        </a>
      </div>
    </section>
  </div>
</template>
<script>
import mobileChecker from '@/mixins/mobileChecker'
import { mapGetters } from 'vuex'

export default {
  mixins: [mobileChecker],
  data() {
    return {
      link_instagram: null,
      link_whatsapp: null,
      instagramMedia: []
    }
  },
  computed: {
    ...mapGetters(['instagram_token'])
  },
  mounted() {
    this.link_instagram = this.$instagram
    this.link_whatsapp = this.$whatsapp

    this.$store.dispatch('getInstagramMedia').then((data) => {
      this.instagramMedia = data.data.slice(0, 6)
    })
  }
}
</script>
<style scoped lang="scss">
#home-tendencias {
  width: 100%;
  max-width: 2200px;
  margin: auto;
  background-color: $color-quaternary;
  height: calc(100vh - var(--header-height));
  max-height: 1500px;
  position: relative;
  overflow: hidden;

  @media (max-width: 767px) {
    height: unset;
    max-height: unset;
  }
  @media (min-width: 768px) {
    height: unset;
  }
  @media (min-width: 992px) {
    height: calc(100vh - var(--header-height));
  }

  .section-bg{
    clip-path: polygon(100% 86%, 100% 100%, 0 100%, 0 37%);
    background: $color-beige;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: -10px;
    left: 0;
    z-index: 0;
  }

  .clipped-bg{
    display: flex;
    align-items: center;
    padding: 0 2rem;
    background:
		radial-gradient(circle farthest-corner at 230px 100px , #fff 14px, rgba(204, 153, 153, 0) 14px),
		linear-gradient(-10deg, lighten(rgba(purple,0.1), 10%) 70%, blue 110% ),
		radial-gradient(circle farthest-corner at 30% 100%, lighten(yellow, 30%) 0%, rgba(orange, 0.2) 40%),
		linear-gradient(20deg, red, lighten(purple, 10%), blue);
    background-clip: text;
    cursor: pointer;

    &:hover{
      i, span {
        text-shadow: 0 5px 6px rgba(black, 0.15);
      }
    }

    i{
      color: transparent;
      font-size: 36px;
      margin-right: 0.5rem;
      transition: all ease-in-out 0.2s;
    }

    span{
      font-size: 36px;
      line-height: 36px;
      font-weight: 500;
      color: transparent;
      transition: all ease-in-out 0.2s;

    }
  }

  .instagramMedia-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2rem;
  width: auto;
  margin: 0 auto;
  
  

  @media (max-width: 576px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    padding: 0;
    gap: 1rem;
    width: 100%;
  }
  @media (min-width: 577px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    padding: 0;
    gap: 1rem;
    width: 100%;
  }
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    padding: 0;
    gap: 1rem;
    width: 100%;
  }
  @media (min-width: 1200px) {
    height: 80%;
    width: unset;
  }

  a {
    height: 100%;
    width: 100%;
    aspect-ratio: 1/1;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 0.2s ease-in-out;
    border-radius: 1rem;
    box-shadow: 0 3px 4px rgba(black, 0.35);

    &:hover {
      opacity: 0.8;
      box-shadow: 0 5px 6px rgba(black, 0.35);
    }

    @media (max-width: 576px) {
      border-radius: 0.7rem;
    }
  }
}

  .sc-main {
    width: 100%;
    padding: 1.5rem 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;

    @media (max-width: 767px) {
      padding: 4rem 7%;
    }
    @media (min-width: 768px) {
      padding: 1.5rem 7%;
    }
    @media (min-width: 992px) {
      height: 100%;
      padding: 1.5rem 7%;
    }
    @media (min-width: 1200px) {
      padding: 0.5rem 10% 4rem 10%;
    }
    @media (min-width: 1460px) {
      padding: 1rem 10% 3rem 10%;
    }

    .ig-data {
      display: flex;
      width: 100%;
      justify-content: center;

      @media (max-width: 767px) {
        height: unset;
        padding-bottom: 1.3rem;
      }
      @media (min-width: 768px) {
        height: unset;
        padding-bottom: 1rem;
      }
      @media (min-width: 992px) {
        padding-bottom: 1.5rem;
      }
      @media (min-width: 1200px) {
      }
      @media (min-width: 1460px) {
      }
    }

    .mos-btn {
      i {
        font-size: 22px;
        margin-right: 0.5rem;
      }

      @media (max-width: 767px) {
        width: 100%;
        justify-content: center;
        padding: 0.75rem;
      }
    }

    .ig-feed {
      width: 100%;
      @media (max-width: 767px) {
        height: unset;
      }
      @media (min-width: 768px) {
        height: unset;
      }
      @media (min-width: 992px) {
        height: 80%;
      }
      @media (min-width: 1200px) {
      }
      @media (min-width: 1460px) {
        height: 85%;
      }
    }
  }
}
</style>
